"use strict";
exports.__esModule = true;
exports.data = void 0;
exports.data = [
    {
        uuid: 'uuid1',
        instance: { uuid: 'uuid1' },
        product: { id: 1 },
        subject: 'Test Email',
        body: '',
        recipients: 'john.doe@test.com',
        from: 'info@ourproduct.com',
        logDateAdded: new Date()
    }
];
